<template>
    <div id="app">
        <router-view />
        <!-- 完善资料 -->
        <ImproveProfile />

        <!-- 验证码 -->
        <captcha />

        <!-- 支付密码 -->
        <password_pay />
    </div>
</template>

<script>
    import store from "../src/vuex/store";
    import ImproveProfile from "./pages/_widget/ImproveProfile.vue";
    import captcha from "./pages/components/captcha";
    import password_pay from "./pages/components/password_pay";

    export default {
        name: "app",
        data() {
            return {
                done: false,
            };
        },
        created() {
            if (process.env.NODE_ENV === "production") {
                this.load_shake();
            }

            //客服
            this.load_cs();
        },
        store,
        methods: {
            load_profile(loading) {
                var loading = this.$loading({ text: "加载中..." });

                this.$http
                    .get("/personal/profile")
                    .then((response) => {
                        this.$store.commit("changeAuth", {
                            isLogin: !!response.success,
                            isDone: true,
                        });

                        this.$store.commit("changeProfile", response.success ? response.data : this.$store.state._profile);

                        this.done = response.success;
                    })
                    .catch((res) => {})
                    .then((response) => {
                        this.$nextTick(() => {
                            loading.close();
                        });
                    });
            },
            //检测用户在线状态
            load_shake() {
                this.$http
                    .get("/auth/shake?t=" + +new Date())
                    .then((response) => {})
                    .catch()
                    .then(() => {
                        setTimeout(() => {
                            this.load_shake();
                        }, 30000);
                    });
            },
            load_cs() {
                this.$http.get("customer_service/my").then((response) => {
                    if (response.success) {
                        this.$store.commit("changeCustomerService", response.data);
                    }
                });
            },
        },
        components: {
            ImproveProfile,
            password_pay,
            captcha,
        },
    };
</script>
